import { ThesaurusTerm } from "@skinsoft/types";
import { OfflineDataFetcher } from "../offline-data-fetcher";

export class ThesaurusTermOfflineDataFetcher extends OfflineDataFetcher<ThesaurusTerm> {
    
    constructor(cacheKey: string) {
        super(cacheKey);
    }
}